export default "/assets/images/mila-valentine-mobile-b-w.621a701b9ec82b18.png";